import React, { useEffect, useState, useRef } from "react";
import "./App.css";
import Dust from "./components/Dust";
import Reveal from "./components/Reveal";

// Asset URLs
const IMG = {
  hero: "https://customer-assets.emergentagent.com/job_f90bd8b0-7995-4b2d-ad84-fe39118249b8/artifacts/rqnyl588_WhatsApp%20Image%202026-05-13%20at%2012.04.34.jpeg",
  detail1: "https://customer-assets.emergentagent.com/job_f90bd8b0-7995-4b2d-ad84-fe39118249b8/artifacts/ava3p2tl_WhatsApp%20Image%202026-05-13%20at%2012.04.35.jpeg",
  pair: "https://customer-assets.emergentagent.com/job_f90bd8b0-7995-4b2d-ad84-fe39118249b8/artifacts/om0bhkh5_WhatsApp%20Image%202026-05-13%20at%2012.04.352.jpeg",
  terrace: "https://customer-assets.emergentagent.com/job_f90bd8b0-7995-4b2d-ad84-fe39118249b8/artifacts/7r0ob1er_Immagine%20WhatsApp%202025-08-28%20ore%2020.13.30_e5471560.jpg",
  embers: "https://customer-assets.emergentagent.com/job_f90bd8b0-7995-4b2d-ad84-fe39118249b8/artifacts/1lvbpe7m_Screenshot%202025-08-17%20200144.png",
  interior: "https://www.provalo.eu/wp-content/uploads/2025/07/Provalo_Ristorante-10.jpg",
  smokeVideo: "/media/sguardi.mp4",
};

const BOOKING_URL = "https://pnssm.pro/8u4anwt";

// ---- HERO ----
const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden flex flex-col"
      style={{ background: "var(--carbone)" }}
    >
      {/* Background image with parallax */}
      <div
        className="absolute inset-0 z-0"
        style={{
          transform: `translateY(${scrollY * 0.25}px)`,
          willChange: "transform",
        }}
      >
        <img
          src={IMG.hero}
          alt=""
          className="w-full h-full object-cover opacity-60"
          style={{ filter: "brightness(0.7) contrast(1.05)" }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(10,8,7,0.65) 0%, rgba(10,8,7,0.35) 35%, rgba(10,8,7,0.85) 85%, rgba(10,8,7,1) 100%)",
          }}
        />
      </div>

      <div className="ember-glow" />
      <div className="smoke" />
      <Dust count={28} />

      {/* Top bar */}
      <div className="relative z-10 flex items-center justify-between px-5 md:px-10 pt-6 md:pt-8">
        <div className="font-display italic text-sm md:text-base" style={{ color: "var(--oro)" }} data-testid="brand-logo">
          Provalo<span style={{ color: "var(--crema)" }}>·</span>Lab
        </div>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-book-link"
          className="hidden md:inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[color:var(--crema-soft)] hover:text-[color:var(--oro)] transition-colors"
        >
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: "var(--brace)" }} />
          Prenota
        </a>
      </div>

      {/* Hero content */}
      <div className="relative z-10 flex-1 flex flex-col justify-end px-5 md:px-10 pb-28 md:pb-24">
        <div className="max-w-6xl">
          <Reveal>
            <div className="eyebrow-stack mb-6 md:mb-10" data-testid="hero-eyebrow">
              <span>Provalo-Lab</span>
              <span className="small">Creazione N°01</span>
            </div>
          </Reveal>

          <Reveal delay={1}>
            <h1 className="hero-title" data-testid="hero-title">
              Attimo<em>sphera</em>
            </h1>
          </Reveal>

          <Reveal delay={2}>
            <p
              className="lead mt-6 md:mt-8 max-w-2xl"
              data-testid="hero-subtitle"
            >
              Un boccone. Più attimi. Una nuova esperienza nata nel Provalo-Lab.
            </p>
          </Reveal>

          <Reveal delay={3}>
            <p className="body-p mt-4 md:mt-6 max-w-md text-base md:text-lg" data-testid="hero-microtext">
              Croccante, cremosa, fresca, persistente. Una creazione inedita da vivere solo da Provalo.
            </p>
          </Reveal>

          <Reveal delay={4}>
            <div className="availability-badge mt-7 md:mt-9" data-testid="hero-availability">
              <span className="availability-dot" aria-hidden="true" />
              <span className="availability-text">Solo il giovedì sera</span>
              <span className="availability-sep" aria-hidden="true" />
              <span className="availability-date">Debutto · giovedì 21 maggio</span>
            </div>
          </Reveal>

          <Reveal delay={4}>
            <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 sm:gap-5">
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                data-testid="hero-book-cta"
              >
                Prenota il tuo tavolo
              </a>
              <a
                href="#rito"
                className="btn-ghost"
                data-testid="hero-discover-cta"
              >
                Scopri l'esperienza
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-3 opacity-70">
        <span className="text-[10px] tracking-[0.4em] uppercase" style={{ color: "var(--crema-soft)" }}>
          Scroll
        </span>
        <span className="w-px h-12 block" style={{ background: "linear-gradient(to bottom, var(--oro), transparent)" }} />
      </div>
    </section>
  );
};

// ---- LAB SECTION ----
const LabSection = () => (
  <section
    id="lab"
    data-testid="lab-section"
    className="relative py-16 md:py-44 px-5 md:px-10 overflow-hidden"
    style={{ background: "var(--carbone)" }}
  >
    <div className="smoke" />
    <div className="big-num" style={{ top: "20%", right: "-2%" }}>I</div>

    <div className="relative z-10 max-w-6xl mx-auto grid md:grid-cols-12 gap-10 md:gap-20 items-start">
      <div className="md:col-span-5">
        <Reveal>
          <div className="eyebrow mb-8">Il Laboratorio</div>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="h-section" data-testid="lab-title">
            Nasce dove le idee diventano <em>sapore</em>.
          </h2>
        </Reveal>
      </div>

      <div className="md:col-span-6 md:col-start-7 md:pt-10">
        <Reveal delay={2}>
          <p className="body-p text-lg md:text-xl" data-testid="lab-text">
            Il Provalo-Lab è il nostro spazio di ricerca e sviluppo in cucina.
            Qui non ci limitiamo a creare nuove proposte: progettiamo piccoli
            momenti capaci di sorprendere chi viene da noi, soprattutto chi
            continua a sceglierci nel tempo.
          </p>
        </Reveal>
        <Reveal delay={3}>
          <div className="mt-10 flex items-center gap-4 text-[13px] tracking-[0.32em] uppercase" style={{ color: "var(--oro)" }}>
            <span className="w-12 h-px" style={{ background: "var(--oro)" }} />
            Ricerca · Sviluppo · Rito
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

// ---- MARQUEE ----
const Marquee = () => {
  const items = ["Croccante", "Cremoso", "Fresco", "Persistente", "Caldo", "Inatteso"];
  return (
    <div className="marquee" aria-hidden="true" data-testid="marquee">
      <div className="marquee-track">
        <span>
          {[...items, ...items, ...items].map((w, i) => (
            <React.Fragment key={i}>
              {w}
              <span className="dot" />
            </React.Fragment>
          ))}
        </span>
      </div>
    </div>
  );
};

// ---- RITO SECTION ----
const RitoSection = () => (
  <section
    id="rito"
    data-testid="rito-section"
    className="relative py-16 md:py-44 px-5 md:px-10 overflow-hidden"
    style={{ background: "var(--carbone-2)" }}
  >
    <div className="ember-glow" style={{ bottom: "-30%", opacity: 0.5 }} />
    <Dust count={16} />

    <div className="relative z-10 max-w-6xl mx-auto">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-6">
          <Reveal>
            <div className="frame" style={{ aspectRatio: "1/1" }}>
              <img src={IMG.detail1} alt="Dettaglio Attimosphera" data-testid="rito-image" />
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-6">
          <Reveal delay={1}>
            <div className="eyebrow mb-8">Il Rito</div>
          </Reveal>
          <Reveal delay={2}>
            <h2 className="h-section" data-testid="rito-title">
              Non è un antipasto.<br />
              È una <em>sequenza</em>.
            </h2>
          </Reveal>
          <Reveal delay={3}>
            <p className="body-p text-lg mt-8" data-testid="rito-text">
              Attimosphera è pensata per essere attraversata in più attimi:
              prima la freschezza, poi il crunch, poi il cuore, poi la
              persistenza. Ogni elemento ha un ruolo preciso. Ogni morso apre
              qualcosa.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

// ---- TRE ATTIMI ----
const ATTIMI = [
  {
    num: "I",
    title: "Il cappello",
    text: "Una piccola fetta di tartufo. Una nota fresca, leggermente acida. Pensato per preparare il palato.",
    accent: "Apertura",
    zoom: { x: "50%", y: "15%", scale: 1.6 },
  },
  {
    num: "II",
    title: "Il cuore",
    text: 'Una sfera generosa — cinque centimetri di diametro. Proprio per questo il "crunch" del guscio sorprende: netto, inatteso, fuori scala. Dentro un cuore caldo e cremoso: note lattiche, tartufo, burro nocciola, fondo bruno. Contrasti che cambiano nel morso e restano oltre.',
    accent: "Centro",
    zoom: { x: "50%", y: "52%", scale: 1.35 },
  },
  {
    num: "III",
    title: "Il finale",
    text: "Il papillon di pasta brisée e la base lattea riportano equilibrio e chiudono l'esperienza.",
    accent: "Chiusura",
    zoom: { x: "50%", y: "92%", scale: 1.2 },
  },
];

const AttimiSection = () => (
  <section
    id="attimi"
    data-testid="attimi-section"
    className="relative py-16 md:py-44 px-5 md:px-10 overflow-hidden"
    style={{ background: "var(--carbone)" }}
  >
    <div className="smoke" />

    <div className="relative z-10 max-w-6xl mx-auto">
      <Reveal>
        <div className="eyebrow mb-8">I Tre Attimi</div>
      </Reveal>
      <Reveal delay={1}>
        <h2 className="h-section max-w-3xl" data-testid="attimi-title">
          Tre momenti, in diversi bocconi.<br />Un'esperienza da <em>ricordare</em>.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-5 md:gap-6">
        {ATTIMI.map((a, i) => (
          <Reveal key={a.title} delay={Math.min(i + 1, 4)}>
            <article className="attimo-card h-full" data-testid={`attimo-card-${i}`}>
              <div
                className="attimo-zoom"
                style={{
                  backgroundImage: `url(${IMG.hero})`,
                  backgroundSize: `${a.zoom.scale * 100}%`,
                  backgroundPosition: `${a.zoom.x} ${a.zoom.y}`,
                }}
                data-testid={`attimo-zoom-${i}`}
              />
              <div className="flex items-baseline justify-between mb-6 mt-2">
                <span className="attimo-num">Attimo {a.num}</span>
                <span className="text-[10px] tracking-[0.3em] uppercase" style={{ color: "var(--muted-text)" }}>
                  {a.accent}
                </span>
              </div>
              <h3
                className="font-display text-4xl md:text-5xl mb-6"
                style={{ color: "var(--crema)" }}
                data-testid={`attimo-title-${i}`}
              >
                {a.title}
              </h3>
              <p className="body-p" data-testid={`attimo-text-${i}`}>
                {a.text}
              </p>
              <div className="mt-10 w-12 h-px" style={{ background: "var(--oro)" }} />
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

// ---- SENSORIALE ----
const SensorialeSection = () => (
  <section
    id="sensoriale"
    data-testid="sensoriale-section"
    className="relative py-16 md:py-44 px-5 md:px-10 overflow-hidden"
    style={{ background: "var(--carbone-2)" }}
  >
    <div
      className="absolute inset-0 opacity-30"
      style={{
        backgroundImage: `url(${IMG.embers})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: "blur(2px) brightness(0.5)",
      }}
    />
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(180deg, var(--carbone-2) 0%, rgba(20,16,13,0.7) 50%, var(--carbone-2) 100%)",
      }}
    />
    <Dust count={20} />

    <div className="relative z-10 max-w-4xl mx-auto text-center">
      <Reveal>
        <div className="eyebrow mb-10 justify-center inline-flex">L'Atmosfera</div>
      </Reveal>
      <Reveal delay={1}>
        <h2 className="h-section" data-testid="sens-title">
          Il gusto non arriva<br />tutto <em>insieme</em>.
        </h2>
      </Reveal>
      <Reveal delay={2}>
        <p className="lead mt-10 md:mt-14 max-w-2xl mx-auto" data-testid="sens-text">
          Prima senti il croccante. Poi il cuore si apre. Poi arrivano le note
          più profonde. E quando pensi che sia finita, il sapore resta ancora
          lì, a insistere. È in quel piccolo ritardo che nasce l'atmosfera.
        </p>
      </Reveal>
    </div>
  </section>
);

// ---- ESCLUSIVITÀ ----
const EsclusivitaSection = () => (
  <section
    id="esclusiva"
    data-testid="esclusiva-section"
    className="relative py-16 md:py-44 px-5 md:px-10 overflow-hidden"
    style={{ background: "var(--carbone)" }}
  >
    <div className="big-num" style={{ bottom: "10%", left: "-2%" }}>·</div>
    <div className="smoke" />

    <div className="relative z-10 max-w-6xl mx-auto grid md:grid-cols-12 gap-10 items-center">
      <div className="md:col-span-7">
        <Reveal>
          <div className="eyebrow mb-8">Esclusività</div>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="h-section" data-testid="escl-title">
            Non la trovi <em>altrove</em>.
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="body-p text-lg mt-8 max-w-xl" data-testid="escl-text">
            Attimosphera è una creazione originale del Provalo-Lab. Una
            proposta inedita, progettata da noi e disponibile solo da Provalo
            Spiedinificio.
          </p>
        </Reveal>
      </div>

      <div className="md:col-span-5">
        <Reveal delay={3}>
          <div className="frame" style={{ aspectRatio: "1/1" }}>
            <img src={IMG.pair} alt="Coppia di Attimosphera" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

// ---- GALLERY ----
const GalleryVideo = () => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) {
      v.play().catch(() => {});
    }
  };

  return (
    <div className="frame relative" style={{ aspectRatio: "9/16", background: "#000", maxHeight: "80vh" }} data-testid="gallery-video-wrap">
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        data-testid="gallery-video"
        style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
      >
        <source src="/media/sguardi.webm" type="video/webm" />
        <source src="/media/sguardi.mp4" type="video/mp4" />
      </video>
      <button
        type="button"
        onClick={toggleMute}
        aria-label={muted ? "Attiva audio" : "Disattiva audio"}
        data-testid="video-mute-toggle"
        className="absolute bottom-4 right-4 w-12 h-12 rounded-full flex items-center justify-center backdrop-blur-md transition-all duration-300 hover:scale-110"
        style={{
          background: muted ? "rgba(217, 83, 30, 0.92)" : "rgba(20, 16, 13, 0.7)",
          border: muted ? "1px solid rgba(244, 234, 213, 0.5)" : "1px solid rgba(200, 169, 106, 0.4)",
          color: "#f4ead5",
          boxShadow: muted ? "0 6px 22px rgba(217, 83, 30, 0.45)" : "0 6px 22px rgba(0,0,0,0.5)",
        }}
      >
        {muted ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
            <line x1="23" y1="9" x2="17" y2="15"/>
            <line x1="17" y1="9" x2="23" y2="15"/>
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
          </svg>
        )}
      </button>
      {muted && (
        <div
          className="absolute bottom-4 right-20 px-3 py-2 rounded-full text-[11px] tracking-[0.18em] uppercase pointer-events-none"
          style={{
            background: "rgba(20, 16, 13, 0.78)",
            color: "var(--crema)",
            border: "1px solid rgba(200, 169, 106, 0.3)",
            backdropFilter: "blur(8px)",
          }}
        >
          Attiva audio
        </div>
      )}
    </div>
  );
};

const GallerySection = () => (
  <section
    id="gallery"
    data-testid="gallery-section"
    className="relative py-16 md:py-36 px-5 md:px-10 overflow-hidden"
    style={{ background: "var(--carbone-2)" }}
  >
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <div className="eyebrow mb-8">Sguardi</div>
      </Reveal>
      <Reveal delay={1}>
        <h2 className="h-section max-w-3xl" data-testid="gallery-title">
          L'occhio prima<br />del <em>morso</em>.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-24 grid grid-cols-12 gap-4 md:gap-5">
        <Reveal className="col-span-12 md:col-span-7">
          <GalleryVideo />
        </Reveal>
        <Reveal delay={1} className="col-span-12 md:col-span-5">
          <div className="frame" style={{ aspectRatio: "1/1" }}>
            <img src={IMG.hero} alt="Attimosphera" data-testid="gallery-2" />
          </div>
        </Reveal>
        <Reveal delay={2} className="col-span-12 md:col-span-4">
          <div className="frame" style={{ aspectRatio: "1/1" }}>
            <img src={IMG.pair} alt="Coppia" data-testid="gallery-3" />
          </div>
        </Reveal>
        <Reveal delay={3} className="col-span-12 md:col-span-8">
          <div className="frame relative overflow-hidden" style={{ aspectRatio: "16/10" }}>
            <img src={IMG.embers} alt="Brace" data-testid="gallery-4" />
            <div className="absolute inset-0 flex items-end p-6 md:p-10">
              <p className="font-display italic text-2xl md:text-4xl" style={{ color: "var(--crema)" }}>
                "Dove la brace<br />diventa idea."
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

// ---- CTA FINALE ----
const CtaSection = () => (
  <section
    id="cta"
    data-testid="cta-section"
    className="relative py-20 md:py-48 px-5 md:px-10 overflow-hidden text-center"
    style={{ background: "var(--carbone)" }}
  >
    <div className="ember-glow" style={{ opacity: 0.9 }} />
    <Dust count={32} />
    <div className="smoke" />

    <div className="relative z-10 max-w-4xl mx-auto">
      <Reveal>
        <div className="eyebrow mb-10 justify-center inline-flex">L'Invito</div>
      </Reveal>
      <Reveal delay={1}>
        <h2 className="hero-title" data-testid="cta-title">
          Vieni a <em>provarla</em>.
        </h2>
      </Reveal>
      <Reveal delay={2}>
        <p className="lead mt-10 max-w-xl mx-auto" data-testid="cta-text">
          Alcune cose si spiegano. Altre si capiscono solo quando arrivano al
          tavolo.
        </p>
      </Reveal>
      <Reveal delay={3}>
        <div className="mt-14 flex flex-col sm:flex-row gap-5 items-center justify-center">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            data-testid="cta-book-button"
          >
            Prenota ora
          </a>
          <a
            href="tel:0665024213"
            className="btn-ghost"
            data-testid="cta-call-button"
          >
            06 6502 4213
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

// ---- FOOTER ----
const Footer = () => (
  <footer
    data-testid="footer"
    className="footer relative px-5 md:px-10 pt-20 pb-32 md:pb-20"
  >
    <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="font-display italic text-3xl md:text-4xl" style={{ color: "var(--crema)" }}>
          Provalo<span style={{ color: "var(--oro)" }}>·</span>Spiedinificio
        </div>
        <p className="body-p mt-6 max-w-sm">
          A 10 minuti dall'aeroporto di Fiumicino. Un rituale conviviale,
          attorno a una brace viva. Qui nasce Attimosphera.
        </p>
      </div>

      <div className="md:col-span-3">
        <div className="eyebrow mb-6">Contatti</div>
        <ul className="space-y-3 text-sm" style={{ color: "var(--crema-soft)" }}>
          <li>
            <a href="tel:0665024213" className="hover:text-[color:var(--oro)] transition-colors" data-testid="footer-phone-1">
              06 6502 4213
            </a>
          </li>
          <li>
            <a href="tel:3347049226" className="hover:text-[color:var(--oro)] transition-colors" data-testid="footer-phone-2">
              334 704 9226
            </a>
          </li>
          <li>
            <a href="mailto:info@provalo.eu" className="hover:text-[color:var(--oro)] transition-colors" data-testid="footer-email">
              info@provalo.eu
            </a>
          </li>
        </ul>
      </div>

      <div className="md:col-span-4">
        <div className="eyebrow mb-6">Esperienza</div>
        <ul className="space-y-2.5 text-base" style={{ color: "var(--crema-soft)" }}>
          <li>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-link"
              className="footer-link"
            >
              <span className="footer-link-arrow">→</span>
              <span>Prenota un tavolo</span>
            </a>
          </li>
          <li>
            <a
              href="https://provalo.eu"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website"
              className="footer-link"
            >
              <span className="footer-link-arrow">→</span>
              <span>provalo.eu</span>
            </a>
          </li>
          <li>
            <a href="#rito" className="footer-link">
              <span className="footer-link-arrow">→</span>
              <span>Scopri Attimosphera</span>
            </a>
          </li>
        </ul>

        <div className="eyebrow mb-5 mt-10">Seguici</div>
        <div className="flex items-center gap-4" data-testid="footer-socials">
          <a
            href="https://www.instagram.com/provalospiedinificio/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-testid="footer-instagram"
            className="social-icon w-11 h-11 inline-flex items-center justify-center rounded-full transition-all duration-500 hover:scale-110"
            style={{
              background: "radial-gradient(circle at 30% 110%, #feda75 0%, #fa7e1e 25%, #d62976 50%, #962fbf 75%, #4f5bd5 100%)",
              color: "#ffffff",
              boxShadow: "0 6px 22px rgba(214, 41, 118, 0.30)",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
            </svg>
          </a>

          <a
            href="https://www.facebook.com/provalo.eu/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            data-testid="footer-facebook"
            className="social-icon w-11 h-11 inline-flex items-center justify-center rounded-full transition-all duration-500 hover:scale-110"
            style={{
              background: "#1877F2",
              color: "#ffffff",
              boxShadow: "0 6px 22px rgba(24, 119, 242, 0.32)",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M13.5 9H16V6h-2.5C11.57 6 10 7.57 10 9.5V11H8v3h2v7h3v-7h2.5l.5-3H13V9.75c0-.41.34-.75.75-.75z"/>
            </svg>
          </a>

          <a
            href="https://api.whatsapp.com/send/?phone=393347049226&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            data-testid="footer-whatsapp"
            className="social-icon w-11 h-11 inline-flex items-center justify-center rounded-full transition-all duration-500 hover:scale-110"
            style={{
              background: "#25D366",
              color: "#ffffff",
              boxShadow: "0 6px 22px rgba(37, 211, 102, 0.32)",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 21.785h-.004c-1.97 0-3.9-.53-5.585-1.527L6.05 19.96l-4.225 1.108 1.13-4.123-.273-.435A9.86 9.86 0 0 1 1.21 11.69c0-5.45 4.436-9.884 9.89-9.884 2.642 0 5.124 1.03 6.99 2.898a9.825 9.825 0 0 1 2.894 6.99c-.003 5.45-4.437 9.881-9.884 9.881zm8.413-18.297A11.815 11.815 0 0 0 11.978 0C5.43 0 .1 5.33.099 11.878a11.86 11.86 0 0 0 1.584 5.937L0 24l6.336-1.66a11.875 11.875 0 0 0 5.638 1.434h.005c6.555 0 11.886-5.33 11.889-11.879a11.84 11.84 0 0 0-3.481-8.407z"/>
            </svg>
          </a>
        </div>

        <div className="eyebrow mb-5 mt-10">Il nostro canale WhatsApp</div>
        <a
          href="https://whatsapp.com/channel/0029Vb7Anch1Hsq0C9bMi43T"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-channel"
          className="wa-channel-card"
        >
          <span
            className="w-11 h-11 inline-flex items-center justify-center rounded-full shrink-0"
            style={{
              background: "#25D366",
              color: "#ffffff",
              boxShadow: "0 6px 22px rgba(37, 211, 102, 0.32)",
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M19.077 4.928A9.97 9.97 0 0 0 12.01 2c-5.51 0-9.987 4.476-9.987 9.985 0 1.76.466 3.477 1.34 4.985L2 22l5.13-1.345a9.99 9.99 0 0 0 4.88 1.247h.004c5.51 0 9.987-4.476 9.987-9.985a9.92 9.92 0 0 0-2.924-7.99zM12.01 20.21h-.003a8.34 8.34 0 0 1-4.25-1.165l-.305-.18-3.043.797.812-2.967-.198-.305a8.27 8.27 0 0 1-1.27-4.405c0-4.582 3.728-8.31 8.318-8.31 2.22 0 4.307.866 5.876 2.437a8.26 8.26 0 0 1 2.434 5.881c-.002 4.582-3.73 8.218-8.371 8.218zm4.56-6.227c-.249-.125-1.478-.73-1.706-.813-.229-.083-.395-.125-.561.125-.166.25-.645.812-.79.978-.146.166-.291.187-.541.062-.249-.125-1.054-.388-2.008-1.238-.742-.662-1.243-1.479-1.388-1.728-.146-.25-.016-.385.11-.51.112-.112.249-.291.374-.437.125-.146.166-.25.25-.416.083-.166.041-.312-.021-.437-.062-.125-.561-1.353-.769-1.853-.203-.486-.408-.42-.561-.428-.146-.008-.312-.01-.478-.01a.92.92 0 0 0-.665.312c-.229.25-.873.853-.873 2.08 0 1.226.894 2.412 1.018 2.578.125.166 1.758 2.686 4.26 3.766.595.257 1.06.41 1.423.525.598.19 1.142.163 1.572.099.479-.072 1.478-.604 1.687-1.188.208-.583.208-1.083.146-1.187-.062-.105-.229-.166-.478-.291z"/>
            </svg>
          </span>
          <div className="flex flex-col">
            <span className="wa-channel-title">Unisciti al canale</span>
            <span className="wa-channel-sub">Anteprime, novità & rituali dal Lab</span>
          </div>
          <span className="wa-channel-arrow">→</span>
        </a>
      </div>
    </div>

    <div className="max-w-6xl mx-auto mt-16 pt-8 border-t flex flex-col md:flex-row gap-4 items-start md:items-center justify-between text-xs" style={{ borderColor: "rgba(200, 169, 106, 0.15)", color: "var(--muted-text)" }}>
      <p>© {new Date().getFullYear()} Provalo Spiedinificio · Tutti i diritti riservati</p>
      <p className="font-display italic">Attimosphera · Una creazione del Provalo-Lab</p>
    </div>
  </footer>
);

// ---- STICKY MOBILE CTA ----
const StickyCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="sticky-cta md:hidden"
      data-testid="sticky-cta-mobile"
      style={{ animation: "fadeInUp 0.6s ease both" }}
    >
      Prenota Attimosphera
    </a>
  );
};

// ---- APP ----
function App() {
  // Smooth scroll for anchor links
  useEffect(() => {
    const handler = (e) => {
      const t = e.target.closest('a[href^="#"]');
      if (!t) return;
      const id = t.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div className="App relative" data-testid="app-root">
      <div className="grain" />

      <Hero />
      <LabSection />
      <Marquee />
      <RitoSection />
      <AttimiSection />
      <SensorialeSection />
      <EsclusivitaSection />
      <GallerySection />
      <CtaSection />
      <Footer />

      <StickyCta />
    </div>
  );
}

export default App;
